import {Header} from './Header/client';
import {Slider} from './Slider/client';
import {ToTop} from './ToTop/client';

customElements.define('x-header', Header);
customElements.define('x-slider', Slider);
customElements.define('x-to-top', ToTop);
